module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "bodyPadding",
    attrs: {
      "id": "inspire"
    }
  }, [_c('mo-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "qtePopup"
    }
  }, [_c('div', {
    attrs: {
      "id": "qtePopupHeader"
    }
  }, [_c('div', {
    attrs: {
      "id": "qtePopupHeader-Container"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "id": "qtePopupClose"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncGoLite()
      }
    }
  }, [_vm._v("\n            All Quotes\n          ")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "qtePopupQteNumber"
    }
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.quote_no) + " - Quote Details")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "qtePopupContent"
    }
  }, [_c('div', {
    staticClass: "row icons"
  }, [_c('div', [(_vm.objAuthorize.manufacturer == '385889803' && _vm.quoteSingle.quote.hide_quote_edit == true) ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "editQuote"
    },
    on: {
      "click": _vm.fncEditQuote
    }
  }, [_vm._v("Edit"), _c('br'), _vm._v("Quote")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803' && _vm.quoteSingle.quote.totalFullPrice == '0' && _vm.quoteSingle.quote.calculator_links != '' && _vm.quoteSingle.quote.calculator_links != 'null' && _vm.quoteSingle.quote.calculator_links != null) ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "openCalculator"
    },
    on: {
      "click": function($event) {
        return _vm.fncOpenCalculator()
      }
    }
  }, [_vm._v("Open"), _c('br'), _vm._v("Calculator")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "viewQuote"
    },
    on: {
      "click": function($event) {
        return _vm.fncViewQuote()
      }
    }
  }, [_vm._v("View"), _c('br'), _vm._v("Quote")]), _vm._v(" "), (_vm.quoteSingle.quote.totalFullPrice != '0') ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "downloadQuote"
    },
    on: {
      "click": function($event) {
        return _vm.fncDownloadQuote()
      }
    }
  }, [_vm._v("Download"), _c('br'), _vm._v("Quote")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "notificationHistory"
    },
    on: {
      "click": _vm.fncNotificationHistory
    }
  }, [_vm._v("Notification"), _c('br'), _vm._v("History")]), _vm._v(" "), (_vm.quoteSingle.quote.hasAttachment == '' || _vm.quoteSingle.quote.hasAttachment == 'null' || _vm.quoteSingle.quote.hasAttachment == null) ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "attachments"
    },
    on: {
      "click": function($event) {
        return _vm.fncQuoteAttachments()
      }
    }
  }, [_vm._v("Supporting"), _c('br'), _vm._v("Documents")]) : _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "attachments"
    },
    on: {
      "click": function($event) {
        return _vm.fncQuoteAttachments()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons attachmentTick"
  }, [_vm._v("done")]), _vm._v("Supporting"), _c('br'), _vm._v("Documents")]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "linkedUsers"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetResponsibleReps(_vm.quoteSingle.quote, 0)
      }
    }
  }, [_vm._v("Linked"), _c('br'), _vm._v("Users")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "cloneQuote"
    },
    on: {
      "click": function($event) {
        return _vm.fncCloneQuote()
      }
    }
  }, [_vm._v("Clone"), _c('br'), _vm._v("Quote")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf("CAN_ARCHIVE") != -1) ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "archiveQuote"
    },
    on: {
      "click": function($event) {
        return _vm.fncArchiveQuote()
      }
    }
  }, [_vm._v("Archive"), _c('br'), _vm._v("Quote")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.quoteSingle.checkedOut == true && _vm.quoteSingle.quote.totalFullPrice != '0') ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "deliveryNote"
    },
    on: {
      "click": function($event) {
        return _vm.fncGenerateDeliveryNote()
      }
    }
  }, [_vm._v("Download"), _c('br'), _vm._v("Delivery Note")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('button', {
    staticClass: "primary-icon-btn",
    attrs: {
      "id": "apiDetails"
    },
    on: {
      "click": function($event) {
        return _vm.fncApiDetails()
      }
    }
  }, [_vm._v("API"), _c('br'), _vm._v("Details")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "id": "section-Department"
    }
  }, [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Department")]), _vm._v(" "), (_vm.quoteSingle.quote.department_name != '' && _vm.quoteSingle.quote.department_name != 'null' && _vm.quoteSingle.quote.department_name != null) ? _c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.department_name))]) : _c('span', {
    staticClass: "itemData"
  }, [_vm._v("Not Set")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "section-Total"
    }
  }, [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Total Excl VAT")]), _vm._v(" "), _c('span', {
    staticClass: "itemData"
  }, [_vm._v("R" + _vm._s(_vm.quoteSingle.quote.vatPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")))])]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('div', {
    staticClass: "item",
    attrs: {
      "id": "section-PONumber"
    }
  }, [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("PO Number")]), _vm._v(" "), _c('span', {
    staticClass: "itemData",
    domProps: {
      "innerHTML": _vm._s(_vm.fncFormatPo(_vm.quoteSingle.quote.purchase_order_numbers))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('div', {
    staticClass: "item",
    attrs: {
      "id": "section-SONumber"
    }
  }, [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("SO Number")]), _vm._v(" "), _c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.sales_order_number))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "section-orderNumber"
    }
  }, [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Order Number")]), _vm._v(" "), _c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.order_no))])])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "section-Status"
    }
  }, [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Current Status")]), _vm._v(" "), _c('span', {
    staticClass: "itemData",
    attrs: {
      "id": _vm.fncSetId(_vm.quoteSingle.quote.id)
    }
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.quoteStatus))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CANNOT_UPDATE_STATUS') == -1) ? _c('button', {
    staticClass: "primary-btn",
    attrs: {
      "id": "updateStatus"
    },
    on: {
      "click": function($event) {
        return _vm.fncEditStatusPopup()
      }
    }
  }, [_vm._v("Update Status")]) : _vm._e(), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card-columns"
  }, [_c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-quoteDetails"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("QUOTE DETAILS")]), _vm._v(" "), _c('table', [_c('tr', {
    attrs: {
      "id": "item-creationDate"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Creation Date:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.quoteCreated))])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "item-quoteAge"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Quote Age:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.age) + " days")])])]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('tr', {
    staticClass: "seperator"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "seperator-line"
  })])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('tr', {
    attrs: {
      "id": "item-quoteType"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Quote Created with:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.quote_type))])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803' && _vm.quoteSingle.quote.calc_type != 'Lookup Service' && _vm.quoteSingle.quote.calc_type != 'Service Form' && _vm.quoteSingle.quote.calc_type != 'Service Type') ? _c('tr', {
    attrs: {
      "id": "item-calculator"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Calculator used:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.calc_type))])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('tr', {
    attrs: {
      "id": "item-serviceType"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Service Type:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData",
    domProps: {
      "innerHTML": _vm._s(_vm.fncServiceType())
    }
  })]), _vm._v(" "), (_vm.quoteSingle.quote.calc_type == 'Service Form') ? _c('td', [_c('a', {
    staticClass: "secondary-link",
    attrs: {
      "id": "editServiceForm"
    },
    on: {
      "click": function($event) {
        return _vm.fncEditSurveyDoc()
      }
    }
  }, [_vm._v("Edit Form")])]) : _c('td'), _vm._v(" "), (_vm.quoteSingle.quote.calc_type == 'Service Form') ? _c('td', [_c('a', {
    staticClass: "secondary-link",
    attrs: {
      "id": "downloadServiceForm"
    },
    on: {
      "click": function($event) {
        return _vm.fncDownloadSurveyDoc()
      }
    }
  }, [_vm._v("Download Form")])]) : _c('td')]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('tr', {
    attrs: {
      "id": "item-surveyType"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Engagement Type:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "itemData",
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetSurveyType())
    }
  })])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "seperator"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "seperator-line"
  })])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "item-originator"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Originator:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('a', {
    staticClass: " link itemData",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.fncShowOriginator()
      }
    }
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.name) + " " + _vm._s(_vm.quoteSingle.quote.surname))])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "item-originatorType"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Originator Type:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.userType))])])]), _vm._v(" "), _c('tr', {
    staticClass: "seperator"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "seperator-line"
  })])]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('tr', {
    attrs: {
      "id": "item-linkedQuotes"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Linked Quotes:")])]), _vm._v(" "), (_vm.quoteSingle.quote.linked_quotes == 'None') ? _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("None")]) : _c('td', {
    attrs: {
      "colspan": "3"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncShowLinkedQuotes())
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.quoteSingle.quote.external_ref != '' && _vm.quoteSingle.quote.external_ref != null && _vm.quoteSingle.quote.external_ref != 'null') ? _c('tr', {
    attrs: {
      "id": "item-companyName"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("External Reference:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.external_ref))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-customerDetails"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("CUSTOMER DETAILS")]), _vm._v(" "), _c('table', [_c('tr', {
    attrs: {
      "id": "item-customerName"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Name:")])]), _vm._v(" "), (_vm.quoteSingle.customer.length > 0) ? _c('td', [_c('a', {
    staticClass: "itemData link",
    on: {
      "click": function($event) {
        return _vm.fncShowCustomer()
      }
    }
  }, [_vm._v(_vm._s(_vm.quoteSingle.customer[0].name) + " " + _vm._s(_vm.quoteSingle.customer[0].surname))])]) : _c('td', [_c('span', {
    staticClass: "itemData link"
  }, [_vm._v("No customer has been set")])])]), _vm._v(" "), (_vm.quoteSingle.customer.length > 0) ? _c('tr', {
    attrs: {
      "id": "item-customerEmail"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Email:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.customer[0].email))])])]) : _vm._e(), _vm._v(" "), (_vm.quoteSingle.customer.length > 0) ? _c('tr', {
    attrs: {
      "id": "item-customerTelephone"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Telephone:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.customer[0].contactnum))])])]) : _vm._e(), _vm._v(" "), (_vm.quoteSingle.customer.length > 0) ? _c('tr', {
    attrs: {
      "id": "item-companyName"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Company:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.customer[0].companyName))])])]) : _vm._e(), _vm._v(" "), (_vm.quoteSingle.quote.memo != '') ? _c('tr', {
    attrs: {
      "id": "item-companyName"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Memo:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.memo))])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "item-deliveryMethod"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Delivery Method:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.delivery_method))])])])])]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-recipients"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("ADDITIONAL NOTIFICATION RECIPIENTS\n                "), _c('div', {
    staticClass: "sectionSubHeader"
  }, [_vm._v("Notifications for this quote will also be sent to the below non-MyOrder recipients.")])]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "item-customerRecipientValue"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Customer Recipient:")])]), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-around"
    }
  }, [(_vm.quoteSingle.quote.customer_recipient != '') ? _c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncFormatHtml(_vm.quoteSingle.quote.customer_recipient))
    }
  }) : _c('a', {
    staticClass: "itemData"
  }, [_vm._v("Not Set")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.fncEditCustomerRecipient()
      }
    }
  }, [_vm._v("ADD")])], 1)])]), _vm._v(" "), _c('tr', {
    staticClass: "seperator"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "seperator-line"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "item-vendorRecipientValue"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Vendor Recipient:")])]), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-around"
    }
  }, [(_vm.quoteSingle.quote.vendor_recipient != '') ? _c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncFormatHtml(_vm.quoteSingle.quote.vendor_recipient))
    }
  }) : _c('a', {
    staticClass: "itemData"
  }, [_vm._v("Not Set")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.fncEditVendorRecipient()
      }
    }
  }, [_vm._v("ADD")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-statusHistory"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("STATUS HISTORY")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "item-previousStatus"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Previous Status:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.audits[0].prev_value))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-statusComment"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Comment:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.audits[0].data))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-statusDateChanged"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Date Changed:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.audits[0].timsetamp))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-statusChangedBy"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Changed By:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.audits[0].changed_by))])])]), _vm._v(" "), _c('tr', {
    staticClass: "seperator"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "seperator-line"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    staticClass: "viewAllStatusHistory secondary-link",
    on: {
      "click": function($event) {
        return _vm.fncViewStatusHistory()
      }
    }
  }, [_vm._v("View all status changes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "seperator"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "seperator-line"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "item-statusCancelReason"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Cancellation Reason:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData",
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetDescription('fs_job_cancelled'))
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "item-statusRejectReason"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Reject Reason:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData",
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetDescription('is_rejected'))
    }
  })])])])]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-vendor"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("VENDOR")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "item-store"
  }, [_c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.vendor_name))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-store"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("STORE")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "item-store"
  }, [(_vm.quoteSingle.quoteItems[0].name != '' && _vm.quoteSingle.quoteItems[0].name != 'null' && _vm.quoteSingle.quoteItems[0].name != null) ? _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quoteItems[0].name))])]) : _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v("Not Set")])]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('td', [(_vm.objAuthorize.privileges.indexOf('CAN_UPDATE_STORE') != -1 && _vm.objAuthorize.manufacturer == '385889803') ? _c('a', {
    staticClass: "secondary-link",
    attrs: {
      "id": "changeStore"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncUpdateStore()
      }
    }
  }, [_vm._v("Change Store")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('td', [(_vm.objAuthorize.manufacturer == '385889803') ? _c('a', {
    staticClass: "secondary-link",
    attrs: {
      "id": "changeAudit",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncStoreAudits()
      }
    }
  }, [_vm._v("Store Audit")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-manufacturerDate"
    }
  }, [_c('div', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Manufacture Date:")]), _vm._v(" "), _c('span', {
    staticClass: "itemData"
  }, [_c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "valueType": "format",
      "placeholder": "Manufacturer Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    on: {
      "change": function($event) {
        return _vm.fncUpdateDate('manufacturer')
      }
    },
    model: {
      value: (_vm.quoteSingle.quote.manufacturer_date_api),
      callback: function($$v) {
        _vm.$set(_vm.quoteSingle.quote, "manufacturer_date_api", $$v)
      },
      expression: "quoteSingle.quote.manufacturer_date_api"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Delivery Date:")]), _vm._v(" "), _c('span', {
    staticClass: "itemData"
  }, [_c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "valueType": "format",
      "placeholder": "Delivery Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    on: {
      "change": function($event) {
        return _vm.fncUpdateDate('delivery')
      }
    },
    model: {
      value: (_vm.quoteSingle.quote.delivery_date_api),
      callback: function($$v) {
        _vm.$set(_vm.quoteSingle.quote, "delivery_date_api", $$v)
      },
      expression: "quoteSingle.quote.delivery_date_api"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-roleSpecific"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("ROLE SPECIFIC")]), _vm._v(" "), (_vm.quoteSingle.quoteReps.length == 0) ? _c('p', [_vm._v("No one has been linked to this quote.")]) : _vm._e(), _vm._v(" "), _c('table', _vm._l((_vm.quoteSingle.quoteReps), function(v, k) {
    return _c('tr', {
      staticClass: "item-roleSpecific"
    }, [_c('td', [_c('span', {
      staticClass: "itemHeader"
    }, [_vm._v(_vm._s(v.roleName))])]), _vm._v(" "), _c('td', [(_vm.objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1) ? _c('a', {
      staticClass: "itemData link",
      on: {
        "click": function($event) {
          return _vm.fncSetResponsibleReps(_vm.quoteSingle.quote, 0)
        }
      }
    }, [_vm._v(_vm._s(v.name) + " " + _vm._s(v.surname))]) : _c('span', {
      staticClass: "itemData"
    }, [_vm._v(_vm._s(v.name) + " " + _vm._s(v.surname))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "card p-3",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "section-discount"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("DISCOUNT")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "item-prediscountValue"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Pre-discount Value:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v("R" + _vm._s(_vm.quoteSingle.quote.totalPrice.toFixed(2)))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-discountValue"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Discount Value:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v("R" + _vm._s(_vm.quoteSingle.quote.totalDiscount.toFixed(2)))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-discount%"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Discount %:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.discountPercentage))])])])])]), _vm._v(" "), (_vm.quoteSingle.quote.installation == true) ? _c('div', {
    staticClass: "card p-3",
    attrs: {
      "id": "section-installation"
    }
  }, [_c('div', {
    staticClass: "sectionHeader"
  }, [_vm._v("INSTALLATION")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "item-lookupRef"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Lookup Service Ref:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData link"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.installation_lookup_ref))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-installationDate"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Installation Date:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData link"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.installation_date))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-installationTime"
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Installation Time:")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData link"
  }, [_vm._v(_vm._s(_vm.quoteSingle.quote.installation_time))])])]), _vm._v(" "), _c('tr', {
    staticClass: "item-onsiteTime",
    staticStyle: {
      "display": "none"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Onsite Time")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData",
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetDescription('fs_on_site'))
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "item-jobCompleteDate",
    staticStyle: {
      "display": "none"
    }
  }, [_c('td', [_c('span', {
    staticClass: "itemHeader"
  }, [_vm._v("Job Complete Date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "itemData",
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetDescription('fs_job_complete'))
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "seperator"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "seperator-line"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    staticClass: "secondary-link",
    attrs: {
      "id": "viewInstallationQuote"
    },
    on: {
      "click": function($event) {
        return _vm.fncViewQuote()
      }
    }
  }, [_vm._v("View Details")])])])])]) : _vm._e()])])])])], 1)
},staticRenderFns: []}